import { useMutation } from "react-query";
import paths from "API/paths";
import axiosInstance from "Services/axiosConfig";

export interface AddMappedSegmentsPayload {
  projectId: string;
  segmentId: string;
  featureId: string;
  treatmentId: string;
}

const addMappedSegments = async (payload: AddMappedSegmentsPayload) => {
  try {
    const url = paths.addMappedSegments();
    const response = await axiosInstance.post(url, { input: payload });
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const useAddMappedSegments = () => {
  return useMutation(addMappedSegments);
};
